export enum MerchantTypeEnum {
  INDEPENDANT = 'INDEPENDANT',
  NATIONAL = 'NATIONAL'
}
